// `/legal/privacy` + `/legal/tos` — юридические документы HealthLab.
//
// HEAL-3: до 05.08.2026 здесь лежали DRAFT-заглушки с плашками «финальный текст будет
// заменён в Sprint 7» и «экран нужен для тестирования flow consent» — их видел живой
// пользователь перед тем, как отдать медицинские данные. Теперь рендерятся финальные
// тексты из @/content/legal (единый источник, там же версия и контакты).
//
// HEAL-69: сама разметка документа переехала в components/legal/LegalDocBody — её делят
// эта страница и лист, который открывается с экрана регистрации.

import { useLocation } from 'wouter';
import { MobileFrame } from '@/components/layout/MobileFrame';
import { ScreenHeader } from '@/components/layout/ScreenHeader';
import { LegalDocBody } from '@/components/legal/LegalDocBody';
import { legalDocs, type LegalKind } from '@/content/legal';

export function LegalPage({ kind }: { kind: LegalKind }) {
  const [, setLocation] = useLocation();
  const doc = legalDocs[kind];

  const goBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      setLocation('/consent');
    }
  };

  return (
    <MobileFrame>
      {/* Пункт 3 тикета: в шапке — конкретный документ, а не «Юридический документ». */}
      <ScreenHeader onBack={goBack} title={doc.title} />

      <main className="flex-1 overflow-y-auto px-6 pb-10 pt-2">
        <LegalDocBody doc={doc} />
      </main>
    </MobileFrame>
  );
}
